export default {
  root: {
    width: '100%',
    marginTop: 60,
    overflowX: 'auto'
  },
  table: {
    minWidth: 700,
    marginBottom: 60
  },
  thead: {
    background: '#efefef',
    fontSize: '14px !important'
  },
  h3: {
    paddingLeft: 22
  }
};



// WEBPACK FOOTER //
// ./src/components/Table/Table.css.js